import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Layout } from '../components/Layout';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Truck, Users, AlertCircle } from 'lucide-react';

/**
 * MyVehicle page - redirects to assigned vehicle or shows empty state
 * - If user has assigned vehicle -> redirect to /vans/{assignedVanId}
 * - If user is unassigned -> show friendly empty state
 */
export const MyVehicle = () => {
  const { assignedVanId, isOwner, isOffice, user } = useAuth();
  const navigate = useNavigate();

  // If user has an assigned vehicle, redirect to it
  if (assignedVanId) {
    return <Navigate to={`/vans/${assignedVanId}`} replace />;
  }

  // Show empty state for unassigned users
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground">My Vehicle</h1>
          <p className="text-muted-foreground mt-1">Your assigned vehicle inventory</p>
        </div>

        <Card className="border-dashed">
          <CardContent className="flex flex-col items-center justify-center py-12 px-4 text-center">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
              <Truck className="w-8 h-8 text-muted-foreground" />
            </div>
            <h2 className="text-xl font-bold text-foreground mb-2">No Vehicle Assigned</h2>
            <p className="text-muted-foreground max-w-md mb-6">
              You don&apos;t have a vehicle assigned to your account yet. 
              {(isOwner || isOffice) 
                ? " You can assign yourself to a vehicle in the Team settings."
                : " Please contact your admin to get assigned to a vehicle."}
            </p>
            
            {(isOwner || isOffice) && (
              <Button onClick={() => navigate('/team')} className="gap-2">
                <Users className="w-4 h-4" />
                Go to Team Settings
              </Button>
            )}

            {!isOwner && !isOffice && (
              <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted/50 px-4 py-2 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                Contact your team owner to be assigned to a vehicle
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};
